import React from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  Typography,
  Button
} from '@material-tailwind/react';
import { UserGroupIcon } from '@heroicons/react/24/outline';

const Customers = () => {
  return (
    <div className="w-full">
      <Card className="w-full max-w-[800px] mx-auto">
        <CardHeader floated={false} shadow={false} className="p-6">
          <Typography variant="h5" color="blue-gray">
            Customer Management
          </Typography>
          <Typography color="gray" className="mt-1 font-normal">
            Track and manage your customer relationships
          </Typography>
        </CardHeader>
        
        <CardBody className="flex flex-col items-center justify-center p-10 text-center">
          <div className="bg-blue-50 rounded-full p-6 mb-4">
            <UserGroupIcon className="h-12 w-12 text-blue-500" />
          </div>
          
          <Typography variant="h5" color="blue-gray" className="mb-2">
            Coming Soon
          </Typography>
          
          <Typography color="gray" className="max-w-md mb-8">
            The customer management feature is currently under development. You'll soon be able to track customer interactions, manage preferences, and log communication history.
          </Typography>
          
          <Button
            variant="outlined"
            color="blue-gray"
            className="flex items-center gap-3"
            disabled
          >
            <UserGroupIcon className="h-5 w-5" /> Customer Management
          </Button>
        </CardBody>
      </Card>
    </div>
  );
};

export default Customers;